export default "__VITE_ASSET__DI8SiyHV__"